/**
 * Starts a file download without taking the page anywhere.
 *
 * `window.location.href = url` also downloads - the response is an attachment,
 * so the browser keeps the page - but only on paper. In the studio it unloads
 * the SPA, which disconnects the room, drops the local tracks and ends the
 * session; a director who asks for yesterday's file must not lose today's show
 * to get it.
 *
 * A synthetic anchor with `download` costs nothing and stays put. It works
 * because the signed link is same-origin (`/api/recordings/...`): the
 * attribute is ignored cross-origin, and there it would open a tab instead.
 */
export function startDownload(url: string): void {
  const anchor = document.createElement('a');
  anchor.href = url;
  // The server names the file in Content-Disposition; an empty value here asks
  // for a download without overriding that name.
  anchor.download = '';
  anchor.rel = 'noopener';
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
}
